import React, { PureComponent } from 'react';
import b from 'b_';

import './projects-page.css';

import ProjectItemStub from '@components/project-item/project-item.stub';

const class_ = b.with('projects-page-stub');

export default class ProjectsPageStub extends PureComponent {
    public render() {
        return (
            <div className={class_()}>
                <ProjectItemStub type="horizontal" />
                <ProjectItemStub type="horizontal" />
                <ProjectItemStub type="horizontal" />
            </div>
        );
    }
}
